module.exports = __webpack_public_path__ + "img/for-men-4.18176e7.webp";